export const PRIMARY = '#97bbcd';
export const SECONDARY = '#ffb4ae';
